import { FaGithub, FaLinkedin } from 'react-icons/fa';

const LandingPage = () => {
	return (
		<div className='flex flex-col items-center h-full pt-20 md:pt-48'>
			<h1 className='text-3xl md:text-5xl font-bold text-center px-4 mx-4'>
				Christian May - Junior Full‑Stack Engineer crafting modern web experiences.
				</h1>

			<section
				id='about'
				className='px-4 my-10 md:my-24 scroll-mt-20 max-w-full md:max-w-3xl mx-auto'
			>
				<h1 className=' text-xl md:text-2xl font-bold text-center mb-10'>
					About Me
				</h1>
				<p className=' text-base md:text-xl font-bold text-center bg-white dark:bg-surface border border-slate-200 dark:border-border rounded-lg p-4 md:p-10 shadow-sm'>
					I'm a passionate developer who loves to create and build new things.
					My experience lies in developing web applications using React/Redux.
					My love for programming came when I first built a discord bot using
					discord.py. While I was doing that, I fell in love with the process of
					bringing ideas to life with code. When I'm not coding, you can find me
					reading a book, playing video games, or watching sports. I am always looking
					to expand my knowledge and skills, so please feel free to reach out!
				</p>
				<h3 className='text-lg md:text-xl font-bold text-center mb-4 mt-10'>
					My Technologies:
				</h3>
				<div className='flex flex-wrap items-center justify-center'>
					<span>&nbsp;&nbsp;</span>
					<img
						align='center'
						src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg'
						className='h-10'
						alt='javascript logo'
					/>
					<span>&nbsp;&nbsp;</span>
					<img
						align='center'
						src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg'
						className='h-10'
						alt='react logo'
					/>
					<span>&nbsp;&nbsp;</span>
					<img
						align='center'
						src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg'
						className='h-10'
						alt='html5 logo'
					/>
					<span>&nbsp;&nbsp;</span>
					<img align='center' src='/css.svg' className='h-10' alt='css3 logo' />
					<span>&nbsp;&nbsp;</span>
					<img
						align='center'
						src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg'
						className='h-10'
						alt='python logo'
					/>
					<span>&nbsp;&nbsp;</span>
					<img
						align='center'
						src='/docker-mark-blue.png'
						className='h-10'
						alt='docker logo'
					/>
					<span>&nbsp;&nbsp;</span>
					<img
						align='center'
						src='/Postgresql_elephant.svg'
						className='h-10'
						alt='postgresql logo'
					/>
					<span>&nbsp;&nbsp;</span>
					<img
						align='center'
						src='/express-js.png'
						className='h-10'
						alt='express logo'
					/>
				</div>
			</section>

			<section
				id='projects'
				className='min-h-[70vh] px-4 mx-auto flex flex-col justify-center w-full max-w-full md:max-w-3xl scroll-mt-20'
			>
				<h1 className=' text-xl md:text-2xl font-bold text-center mb-10'>
					Projects
				</h1>
				<div className='flex flex-col items-stretch gap-6 mb-10 w-full'>
					<div className='flex flex-col text-lg md:text-xl font-bold cursor-pointer border border-slate-200 dark:border-border rounded-lg p-6 bg-white dark:bg-surface shadow-sm hover:shadow-md transition-shadow duration-300 w-full'>
						<h1 className='text-2xl md:text-3xl font-bold text-center mb-4'>
							MangaVault
						</h1>
						<p className='text-base md:text-xl flex-grow'>
							A modern list manager for anime and manga with personalized curation and quick browsing.
						</p>
						<ul className='list-disc list-inside text-sm md:text-lg mt-2 space-y-1'>
							<li>
								Researched UI stacks (Tailwind, Material). Chose Tailwind for speed, consistency, and full control over design tokens.
							</li>
							<li>
								Compared app state options (Redux Toolkit vs Context + custom reducers). Picked Redux Toolkit for predictable global state and scalable slices.
							</li>
							<li>
								Modeled entities (users, entries, lists) with normalized shapes to simplify updates and enable performant filtering/pagination.
							</li>
							<li>
								Trade‑off: kept client‑side rendering for simpler deploys; optimized perceived performance with memoization and list virtualization where needed.
							</li>
						</ul>
						<div className='flex flex-wrap gap-2 bg-slate-100 dark:bg-dark rounded-lg p-2 justify-center mt-2'>
							<img
								align='center'
								src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg'
								className='h-10'
								alt='javascript logo'
							/>
							<img
								align='center'
								src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg'
								className='h-10'
								alt='react logo'
							/>
							<img
								align='center'
								src='https://raw.githubusercontent.com/reduxjs/redux/master/logo/logo.svg'
								className='h-10'
								alt='redux logo'
							/>
							<img
								align='center'
								src='/tailwindcss.svg'
								className='h-10'
								alt='tailwindcss logo'
							/>
							<img
								align='center'
								src='/express-js.png'
								className='h-10'
								alt='express logo'
							/>
						</div>
						<div className='flex justify-center gap-4 mt-4 text-sm'>
							<a
								href='https://github.com/Mayboyzz/Capstone-Project/tree/dev'
								target='_blank'
								rel='noreferrer'
								className='cursor-pointer hover:underline text-primary'
							>
								Github
							</a>
							<a
								href='https://mangavault.onrender.com/'
								target='_blank'
								rel='noreferrer'
								className='cursor-pointer hover:underline text-secondary'
							>
								Live
							</a>
						</div>
					</div>
					<div className='flex flex-col text-lg md:text-xl font-bold cursor-pointer border border-slate-200 dark:border-border rounded-lg p-6 bg-white dark:bg-surface shadow-sm hover:shadow-md transition-shadow duration-300 w-full'>
						<h1 className='text-2xl md:text-3xl font-bold text-center mb-4'>
							Wander-Home
						</h1>
						<p className='text-base md:text-xl flex-grow'>
							An Airbnb‑style app for listing, discovering, and reviewing stays, built for clarity and speed.
						</p>
						<ul className='list-disc list-inside text-sm md:text-lg mt-2 space-y-1'>
							<li>
								Explored form strategies (React Hook Form vs controlled inputs). Chose simple controlled inputs + custom hooks to keep bundle light.
							</li>
							<li>
								Compared state approaches; used Redux Toolkit to coordinate filters, pagination, and modal UI across pages.
							</li>
							<li>
								Designed REST endpoints with validation and clear error codes to support optimistic UI for create/edit/delete flows.
							</li>
							<li>
								Iterated on listing cards, spacing, and mobile breakpoints after mentor feedback to improve scanability and tap targets.
							</li>
							<li>
								Trade‑off: prioritized straightforward server logic over complex caching; relied on client memoization and query invalidation to stay fast.
							</li>
						</ul>
						<div className='flex flex-wrap gap-2 bg-slate-100 dark:bg-dark rounded-lg p-2 justify-center mt-2'>
							<img
								align='center'
								src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg'
								className='h-10'
								alt='javascript logo'
							/>
							<img
								align='center'
								src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg'
								className='h-10'
								alt='react logo'
							/>
							<img
								align='center'
								src='https://raw.githubusercontent.com/reduxjs/redux/master/logo/logo.svg'
								className='h-10'
								alt='redux logo'
							/>
							<img
								align='center'
								src='/tailwindcss.svg'
								className='h-10'
								alt='tailwindcss logo'
							/>
							<img
								align='center'
								src='/express-js.png'
								className='h-10'
								alt='express logo'
							/>
						</div>
						<div className='flex justify-center gap-4 mt-4 text-sm'>
							<a
								href='https://github.com/Mayboyzz/wander-home'
								target='_blank'
								rel='noreferrer'
								className='cursor-pointer hover:underline text-primary'
							>
								Github
							</a>
							<a
								href='https://wander-home.onrender.com/'
								target='_blank'
								rel='noreferrer'
								className='cursor-pointer hover:underline text-secondary'
							>
								Live
							</a>
						</div>
					</div>
				</div>
			</section>

			<section
				id='socials'
				className='flex flex-col items-center my-10 md:my-20 px-4 w-full max-w-full md:max-w-3xl'
			>
				<h1 className=' text-xl md:text-2xl font-bold mb-6'>Socials</h1>
				<div className='flex flex-col md:flex-row items-center justify-center gap-6 md:gap-4'>
					<a
						href='https://github.com/Mayboyzz'
						target='_blank'
						rel='noreferrer'
						className=' text-lg md:text-xl font-bold hover:text-textSecondary cursor-pointer flex items-center transition-colors duration-300'
					>
						<FaGithub className='text-2xl md:text-xl' />
						<h1 className='ml-2 hover:underline'>Github</h1>
					</a>
					<a
						href='https://linkedin.com/in/christian-may-41277718a'
						target='_blank'
						rel='noreferrer'
						className=' flex cursor-pointer items-center font-bold text-lg transition-colors duration-300 hover:text-textSecondary md:text-xl'
					>
						<FaLinkedin className='text-2xl md:text-xl' />
						<h1 className='ml-2 hover:underline'>LinkedIn</h1>
					</a>
				</div>
			</section>
		</div>
	);
};

export default LandingPage;
